export default {
  identification: 'Identificação',
  country: 'País',
  department: 'Departamento',
  description: 'Descrição',
  charge: 'Posição',
  screen: 'Tela'
}
